import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { SET_TOAST_STATUS, SET_TOAST_OBJECT } from 'store/actions';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
export default function CustomizedSnackbars() {
    const dispatch = useDispatch();
    const { toastObject } = useSelector((state) => state.customization);
    const { uploadingMedia } = useSelector((params) => params.announcements);
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        dispatch({ type: SET_TOAST_OBJECT, toastObject: { status: false } });
    };
    return (
        <>
            {toastObject && toastObject.status && (
                <Stack spacing={2} sx={{ width: '100%' }}>
                    <Snackbar
                        open={toastObject.status}
                        autoHideDuration={6000}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: toastObject?.vertical || 'bottom',
                            horizontal: uploadingMedia?.length ? 'left' : toastObject?.horizontal || 'right'
                        }}
                    >
                        <Alert onClose={handleClose} severity={toastObject.variant} sx={{ width: '100%' }}>
                            {toastObject.message}
                        </Alert>
                    </Snackbar>
                </Stack>
            )}
        </>
    );
}
